import { responseSingle, responseCollection } from '@/store/interfaces/json-api/generics';
import { GetterTree, ActionTree, MutationTree } from 'vuex';
import {
  LiquidationState,
  liquidationKind,
  LiquidationParams
} from '@/store/interfaces/liquidations';
import { RootState } from '@/store/interfaces/rootState';
import liquidationsType from '@/store/types/liquidations';
import { http } from '@/util/HTTP';
import { AxiosError, AxiosResponse } from 'axios';

const namespaced = true;

const initialState = (): LiquidationState => {
  return {
    liquidations: {
      data: [],
      pagination: {},
    },
    liquidation: {},
    liquidationsKinds: { data: [], pagination: {}, },
  };
};

const state: LiquidationState = initialState();
const getters: GetterTree<LiquidationState, RootState> = {
  [liquidationsType.getters.GET_LIQUIDATIONS]: state => {
    return state.liquidations;
  },
  [liquidationsType.getters.GET_LIQUIDATION_KIND_LIST]: state => {
    return state.liquidationsKinds;
  },
  [liquidationsType.getters.GET_SINGLE_LIQUIDATION]: (
    state
  ) => {
    return { data: state.liquidation, };
  },
};
const mutations: MutationTree<LiquidationState> = {
  [liquidationsType.mutations.SET_LIQUIDATIONS]: (
    state,
    liquidations: responseCollection<LiquidationParams>
  ) => {
    state.liquidations.data = liquidations.data;
    state.liquidations.pagination = liquidations.meta.pagination;
  },
  [liquidationsType.mutations.SET_SINGLE_LIQUIDATION]: (
    state,
    liquidation: responseSingle<LiquidationParams>
  ) => {
    state.liquidation = liquidation.data;
  },
  [liquidationsType.mutations.SET_LIQUIDATION_KIND_LIST]: (
    state,
    liquidation: responseCollection<liquidationKind>
  ) => {
    state.liquidationsKinds.data = liquidation.data;
    state.liquidationsKinds.pagination = liquidation.meta.pagination;
  },
};
const actions: ActionTree<LiquidationState, RootState> = {
  [liquidationsType.actions.LIQUIDATION_LIST]: (
    { commit, },
    queryParams = ''
  ) => {
    return new Promise((resolve, reject) => {
      http
        .get(`backoffice/liquidations?status=completed${queryParams}`)
        .then((res: AxiosResponse) => {
          commit(liquidationsType.mutations.SET_LIQUIDATIONS, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [liquidationsType.actions.LIQUIDATION_KIND_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      http
        .get('backoffice/liquidation_kinds')
        .then((res: AxiosResponse) => {
          commit(liquidationsType.mutations.SET_LIQUIDATION_KIND_LIST, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [liquidationsType.actions.SINGLE_LIQUIDATION]: ({ commit, }, id: string) => {
    return new Promise((resolve, reject) => {
      http
        .get(`backoffice/liquidations/${id}`)
        .then((res: AxiosResponse) => {
          commit(liquidationsType.mutations.SET_SINGLE_LIQUIDATION, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        })
        .finally(() => {

        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
